const posterUrls = {
  'A New Hope':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114050/star-wars-app/a-new-hope_dgcgm7.jpg',
  'Attack of the Clones':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114052/star-wars-app/attack-of-the-clones_giklnh.jpg',
  'The Phantom Menace':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114051/star-wars-app/the-phantom-menace_duuiup.jpg',
  'Revenge of the Sith':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114052/star-wars-app/revenge-of-the-sith_sfswq0.jpg',
  'Return of the Jedi':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114051/star-wars-app/return-of-the-jedi_skeqg2.jpg',
  'The Empire Strikes Back':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114051/star-wars-app/the-empire-strikes-back_lgqujy.jpg',
  'The Force Awakens':
    'https://res.cloudinary.com/rabeeraadcode/image/upload/v1593114050/star-wars-app/the-force-awakens_x5rgi4.jpg',
};

export default posterUrls;
